import ViewerConfig from "@/Models/ViewerConfig";
import { Viewer, XKTLoaderPlugin } from "@xeokit/xeokit-sdk";
import Model from "../../Models/Model";

export interface XktState {
    models: Model[];
    viewer: Viewer | null;
    loaderPlugin: XKTLoaderPlugin | null;
    viewerConfig: ViewerConfig | null;
}

export const initialXktState: XktState = {
    viewer: null,
    models: [],
    loaderPlugin: null,
    viewerConfig: null,
};
